import React from "react";
import NavContent from "../NavContent/NavContent";

function Navbar() {
  const flexItems = `flex items-center`;

  return (
    <>
      <nav
        className={`${flexItems}  num-vazir border-b border-ws-gray-200   relative px-16 xxl:px-0  bg-ws-gray-200    `}
      >
        <div className="xxl:container justify-between items-center mx-0 xxl:mx-auto hidden lg:flex   w-full nav-container">
          <NavContent />
        </div>
      </nav>
    </>
  );
}

export default Navbar;
